import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/EmailLogin/shared/EmailLoginOrDivider";
import React from "react";
import { cn } from "utils";
import type { EmailLoginVariant } from "../types";

const I18n = I18nUtil.createScoped(Translations);

const DIVIDER_CLASS: Record<EmailLoginVariant, string> = {
  desktop: "bg-border_white_transparent20",
  mobile: "bg-[#e9ebdecc]",
  popup: "bg-[#e9ebdecc]",
};

interface EmailLoginOrDividerProps {
  variant: EmailLoginVariant;
  className?: string;
}

export function EmailLoginOrDivider({
  variant,
  className,
}: EmailLoginOrDividerProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <div className={cn("h-px flex-1", DIVIDER_CLASS[variant])} />
      <span className="body_s text-content_tertiary">{I18n.t("or")}</span>
      <div className={cn("h-px flex-1", DIVIDER_CLASS[variant])} />
    </div>
  );
}
